import React from 'react'

export enum Direction {
  Normal = 'normal',
  Reverse = 'reverse',
  None = 'none',
}

export type Props = {
  className?: string
  style?: React.CSSProperties
  speed?: number
  axis?: 'x' | 'y' | 'xy'
  directionX?: Direction
  directionY?: Direction
}
